"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.configProviderInjectionKey = void 0;
const _utils_1 = require("../../_utils");
exports.configProviderInjectionKey = (0, _utils_1.createInjectionKey)('n-config-provider');
